import { IParams } from '../params';

export const commercialLandParams: (keyof IParams)[] = [
  'publishPeriod',
  'video',
  'landArea',
  'rentTime',
  'rentTerms',
  'comission',
  'wordsInclude',
  'wordsExclude',
  'phone',
  'offerId',
];
